// extracted by mini-css-extract-plugin
export default {"hint":"hint__X4kDi"};